import React, { Fragment, ReactElement } from 'react';
import FlexContainer from '../../../../components/flex-container/flex-container.component';
import FormError from '../../../../components/form-error/form-error.component';
import SinglePageBlock from '../../../../components/single-page-block/single-page-block.component';
import ControlButtonBlock from '../control-button-block/control-button-block.component';
import useScreenMobile from '../../../../hooks/use-screen-mobile';

const SinglePageTab: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement | boolean => {
  const {
    isSaving,
    isEmpty,
    isDark,
    isSaveDisabled,
    isExportDisabled,
    isRightDrawerOpen,
    isEditMode,
    isExportMode,
    isNewEntity,
    isHidden,
    isScrollable,
    isFullHeight,
    withNoBackground,
    withNoTabsOffset,
    withNoPadding,
    withNoButtonBlock,
    formError,
    labelSave,
    onCancelForm,
    onSubmitForm,
    onExportClick,
    children,
  } = props;

  const isMobileScreen: boolean = useScreenMobile();

  const withLoader: boolean = isSaving && (isEditMode || isNewEntity) && !isMobileScreen;

  return !isHidden && (
    <Fragment>
      <SinglePageBlock
        isEmpty={isEmpty}
        isDark={isDark}
        isScrollable={isScrollable}
        isFullHeight={isFullHeight}
        withNoBackground={withNoBackground}
        withNoTabsOffset={withNoTabsOffset}
        withNoPadding={withNoPadding}
      >
        {children}
      </SinglePageBlock>
      <FlexContainer>
        {
          formError && (
            <FormError withOffset withShowError={isEditMode || isNewEntity} error={formError} />
          )
        }
        {
          !withNoButtonBlock && (
            <FlexContainer>
              <ControlButtonBlock
                isNewEntity={isNewEntity}
                isEditMode={isEditMode}
                isExportMode={isExportMode}
                isSaveDisabled={isSaveDisabled}
                isExportDisabled={isExportDisabled}
                withOffset={isRightDrawerOpen}
                withLoader={withLoader}
                labelSave={labelSave}
                onCancelForm={onCancelForm}
                onSubmitForm={onSubmitForm}
                onExportClick={onExportClick}
              />
            </FlexContainer>
          )
        }
      </FlexContainer>
    </Fragment>
  );
});

export default SinglePageTab;
